import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const deleteMealtime = (menuId: string, mealtimeId: string): Promise<any> => {
  return fetch(`${API_URL}/menus/${menuId}/mealtimes/${mealtimeId}`, {
    method: 'DELETE',
  });
};
